__turbopack_context__.v({
  "commentButton": "SocialMediaSharer-module-scss-module__asTHPG__commentButton",
  "commentsCount": "SocialMediaSharer-module-scss-module__asTHPG__commentsCount",
  "isWrapperHorizontal": "SocialMediaSharer-module-scss-module__asTHPG__isWrapperHorizontal",
  "popoverContainer": "SocialMediaSharer-module-scss-module__asTHPG__popoverContainer",
  "wrapper": "SocialMediaSharer-module-scss-module__asTHPG__wrapper",
});
